import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';

import { ChartsModule } from 'ng2-charts-x';

import { VehicleServiceProvider } from '../providers/servicer/vehicle-service';
import { SystemDashboardServiceProvider } from '../providers/servicer/system-dashboard-service';
import { LoadingProvider } from '../providers/loading/loading';
import { SystemSessionServiceProvider } from '../providers/servicer/system-session-service';
import { InputFormProvider } from '../providers/input-form/input-form';
import { SystemMaintOptionsServiceProvider } from '../providers/servicer/system-maint-options-service';
import { SystemMaintStopPointsServiceProvider } from '../providers/servicer/system-maint-stop-points-service';
import { SystemMaintUsersServiceProvider } from '../providers/servicer/system-maint-users-service';
import { SystemMaintAreasServiceProvider } from '../providers/servicer/system-maint-areas-service';
import { SystemMaintVehiclesServiceProvider } from '../providers/servicer/system-maint-vehicles-service';
import { SystemRestPlanServiceProvider } from '../providers/servicer/system-rest-plan-service';
import { SystemWaitPointPlanServiceProvider } from '../providers/servicer/system-wait-point-plan-service';
import { ServicerProvider } from '../providers/servicer/servicer';
import { SystemDashboardIntervalReceiverProvider } from '../providers/system-dashboard-interval-receiver/system-dashboard-interval-receiver';
import { SystemRestPlanDashboardIntervalReceiverProvider } from '../providers/system-rest-plan-dashboard-interval-receiver/system-rest-plan-dashboard-interval-receiver';
import { IntervalReceiverProvider } from '../providers/interval-receiver/interval-receiver';
import { SystemChargePlanServiceProvider } from '../providers/servicer/system-charge-plan-service';

import { LoginComponentModule } from '../components/login/login.module';
import { CustomLoadingComponentModule } from '../components/custom-loading/custom-loading.module';
import { SystemAlertsIntervalReceiverProvider } from '../providers/system-alerts-interval-receiver/system-alerts-interval-receiver';
import { SystemAlertsServiceProvider } from '../providers/servicer/system-alerts-service';
import { AppMonitorIntervalReceiverProvider } from '../providers/app-monitor-interval-receiver/app-monitor-interval-receiver';
import { AppMonitorServiceProvider } from '../providers/servicer/app-monitor-service';
import { AudioService } from '../providers/servicer/audio-service';
import { ReservationAlertService } from '../providers/servicer/reservation-alert-service';
import { CsvLoader } from '../providers/servicer/csv-loader';
import { TimeProvider } from '../providers/time/time';
import { IntervalProvider } from '../providers/interval/interval';
import { SystemDashboardVehiclesServiceProvider } from '../providers/servicer/system-dashboard-vehicles-service';
import { SystemDashboardUsersServiceProvider } from '../providers/servicer/system-dashboard-users-service';
import { SystemDashboardTimetablesServiceProvider } from '../providers/servicer/system-dashboard-timetables-service';
import { SystemDashboardTripPointsServiceProvider } from '../providers/servicer/system-dashboard-trip-points-service';
import { SystemDashboardHistoriesServiceProvider } from '../providers/servicer/system-dashboard-histories-service';
import { EnvironmentProvider } from '../providers/environment/environment';
import { CsvStationLoader } from '../providers/servicer/csv-station-loader';

import { MongoCollectionServiceProvider } from '../providers/servicer/mongo-collection-service';
import { PastIntervalReceiverProvider } from '../providers/interval-receiver/past-interval-receiver';
import { BetweenIntervalReceiverProvider } from '../providers/interval-receiver/between-interval-receiver';
import { BetweenSaveFileProvider } from '../providers/s3/between-save-file';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    ChartsModule,
    HttpClientModule,
    LoginComponentModule,
    CustomLoadingComponentModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    VehicleServiceProvider,
    SystemDashboardServiceProvider,
    LoadingProvider,
    SystemSessionServiceProvider,
    InputFormProvider,
    ServicerProvider,
    SystemMaintOptionsServiceProvider,
    SystemMaintStopPointsServiceProvider,
    SystemMaintUsersServiceProvider,
    SystemMaintAreasServiceProvider,
    SystemMaintVehiclesServiceProvider,
    SystemDashboardIntervalReceiverProvider,
    SystemRestPlanDashboardIntervalReceiverProvider,
    SystemRestPlanServiceProvider,
    SystemWaitPointPlanServiceProvider,
    IntervalReceiverProvider,
    SystemChargePlanServiceProvider,
    SystemAlertsIntervalReceiverProvider,
    SystemAlertsServiceProvider,
    AppMonitorIntervalReceiverProvider,
    AppMonitorServiceProvider,
    AudioService,
    ReservationAlertService,
    CsvLoader,
    TimeProvider,
    IntervalProvider,
    SystemDashboardVehiclesServiceProvider,
    SystemDashboardUsersServiceProvider,
    SystemDashboardTimetablesServiceProvider,
    SystemDashboardTripPointsServiceProvider,
    SystemDashboardHistoriesServiceProvider,
    EnvironmentProvider,
    CsvStationLoader,
    MongoCollectionServiceProvider,
    PastIntervalReceiverProvider,
    BetweenIntervalReceiverProvider,
    BetweenSaveFileProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts